import * as bigjsPlugin from './bigjs'
import * as dayjsPlugin from './dayjs'

export const setup = () => {
  dayjsPlugin.setup()
  bigjsPlugin.setup()
}
